import _ from 'lodash';
import EntryDescription from "module/edesc/EntryDescription";
import {getSisDateAsString} from 'util/SisDateTime';

export const persurlToStringFormat = (attr, {separator = ', ', withShortKey = true} = {}) => {
	let ed = EntryDescription.collection.getFor(attr);
	ed = ed && ed.attributes || {};
	let ret = [
		attr.persNr,
		!withShortKey ? ed.longLabelOnly : ed.longLabel,
		getSisDateAsString(attr.start) + " - " + getSisDateAsString(attr.end),
		attr.text && attr.text.trim() && attr.text,
	];
	return _.compact(ret).join(separator);
};